import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ChatIcon from '../../assets/ChatIcon'
import ReviewCommentDialog from './ReviewCommentDialog'

class CommentIconWithDialog extends Component {
  state = {
    dialogOpen: false,
  }

  toggleDialog = dialogOpen => this.setState({ dialogOpen })

  render() {
    const { review } = this.props
    const { dialogOpen } = this.state
    return (
      <div>
        <span onClick={() => this.toggleDialog(true)}>
          <ChatIcon />
        </span>
        {dialogOpen && (
          <ReviewCommentDialog
            review={review}
            toggleDialog={this.toggleDialog}
          />
        )}
      </div>
    )
  }
}

CommentIconWithDialog.propTypes = {
  review: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    comment: PropTypes.string.isRequired,
  }).isRequired,
}

export default CommentIconWithDialog



// WEBPACK FOOTER //
// ./src/components/sitewide/Reviews/CommentIconWithDialog.js